// src/services/exportMissionClaims.js
import { collection, getDocs, doc, getDoc } from 'firebase/firestore' // ✨ PERBAIKAN: Tambah doc dan getDoc
import { db } from '../firebaseConfig'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export async function exportMissionClaims() {
  const snap = await getDocs(collection(db, 'mission_claim_logs'))

  // ✨ PERBAIKAN: Gunakan Promise.all dan async untuk mengambil data lintas koleksi
  const rows = await Promise.all(snap.docs.map(async (d) => {
    const x = d.data()

    // 1. Ambil Nama Mitra
    let mitraName = '-'
    if (x.mitraId && x.mitraType) {
      const colMitra = x.mitraType === 'cleaner' ? 'cleaners' : 'therapists'
      try {
        const mitraSnap = await getDoc(doc(db, colMitra, x.mitraId))
        if (mitraSnap.exists()) {
          mitraName = mitraSnap.data().name || '-'
        }
      } catch (e) { console.error(e) }
    }

    // 2. Ambil Judul & Target Misi
    let missionTitle = '-'
    let missionTarget = '-'
    if (x.missionId && x.missionScope) {
      const colMission = x.missionScope === 'daily' ? 'missions_daily' : 'missions_weekly'
      try {
        const missionSnap = await getDoc(doc(db, colMission, x.missionId))
        if (missionSnap.exists()) {
          missionTitle = missionSnap.data().title || '-'
          missionTarget = missionSnap.data().target || '-'
        }
      } catch (e) { console.error(e) }
    }

    return {
      'Tanggal Klaim': x.createdAt?.toDate()?.toLocaleString() ?? '',
      'Nama Mitra': mitraName, // ✨ Tampil di Excel
      'Divisi': x.mitraType?.toUpperCase() ?? '-',
      'Judul Misi': missionTitle, // ✨ Tampil di Excel
      'Tipe Misi': x.missionScope === 'daily' ? 'Harian' : 'Mingguan',
      'Syarat Target': missionTarget, // ✨ Tampil di Excel
      'Nominal Bonus': x.bonus ?? 0,
      'Status Approval': x.approved ? 'DISETUJUI' : (x.rejected ? 'DITOLAK' : 'MENUNGGU'),
      'Waktu Disetujui': x.approvedAt?.toDate()?.toLocaleString() ?? '-',
      'Waktu Ditolak': x.rejectedAt?.toDate()?.toLocaleString() ?? '-',
      // ID referensi tetap disimpan di paling ujung untuk kebutuhan audit Admin
      'Ref Mitra ID': x.mitraId,
      'Ref Mission ID': x.missionId, 
    }
  }))

  const ws = XLSX.utils.json_to_sheet(rows)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Mission Claims')

  const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' })

  saveAs(
    new Blob([buf], { type: 'application/octet-stream' }),
    `mission_claims_${Date.now()}.xlsx`
  )
}
